<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title" ref="iframeWidth">나의 페이지2</h4>
            <p class="card-title-desc">
              <code>시작 페이지</code> : 나의 마이샵 홈페이지로 사용합니다.
              <br/>
              <code>이름, 주소</code> : 각 항목을 수정 할 수 있습니다.
              <br/>
              <code>사용 여부</code> : 비활성화 한 경우 페이지가 노출되지 않습니다.
            </p>
            <div class="d-grid">
              <button @click="add_page" type="button" class="btn btn-primary waves-effect waves-light">새로운 페이지 추가 <i style="padding-left: 3px" class="fas fa-plus"></i></button>
            </div>
            <hr/>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                <tr>
                  <th class="text-center">시작 페이지</th>
                  <th>이름</th>
                  <th>주소</th>
                  <th class="text-center">사용 여부</th>
                  <th style="min-width: 200px">기능</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,idx) in pageList" :key="idx">
                  <th scope="row">
                    <my-checkbox @change="changeRoot(item)" v-model="item.rootYn"/>
                  </th>
                  <td>
                    <edit-text @change="changeName(item)" v-model="item.pageName_edit"/>
                  </td>
                  <td>
                    <span style="font-size: 0.8em">{{ item.urlPrefix }}</span>
                    <edit-text @change="changeUrl(item)" v-model="item.pageUrl_edit"/>
                    <button type="button" style="margin-left: 10px" class="btn btn-light btn-sm waves-effect waves-light" @click="copy(item)">복사</button>
                  </td>
                  <td>
                    <my-switch @change="changeDisplay(item)" v-model="item.displayYn"/>
                  </td>
                  <td>
                    <button type="button" style="margin-left: 10px" class="btn btn-light btn-sm waves-effect waves-light" @click="editPage(item)">편집</button>
                    <button type="button" style="margin-left: 10px" class="btn btn-light btn-sm waves-effect waves-light" @click="viewPage(item)">미리보기</button>
                    <button type="button" style="margin-left: 10px" class="btn btn-danger btn-sm waves-effect waves-light" @click="del(item)">삭제</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vue-bottom-sheet ref="myBottomSheet">
      <template-list2
          :embed="true"
          @added="added_page"
          style="padding: 0 15px"/>
    </vue-bottom-sheet>

    <vue-bottom-sheet
        :click-to-close="false"
        :is-full-screen="true"
        :max-width="'100%'"
        :max-height="'98%'"
        :rounded="false"
        ref="editor">
      <div v-if="meditor" style="height: 100%">
        <div class="card-body" style="padding-top: 0;height: 100%">
          <div style="display: flex;flex-direction: column;height: 100%">
            <div class="d-flex">
              <div style="flex:1;padding-right: 10px">
                <a style="width: 100%"
                   @click="save_content"
                   class="btn btn-primary waves-effect waves-light">{{pageName}} 페이지 저장</a>
              </div>
              <div style="padding-right: 10px">
                <a
                    @click="show_content"
                    class="btn btn-light waves-effect waves-light">미리보기</a>
              </div>
              <div>
                <a
                    @click="close_editor"
                    class="btn btn-light waves-effect waves-light">닫기</a>
              </div>
            </div>
            <div style="flex-grow: 1;padding-top: 10px;">
              <editor2
                  ref="content_editor"
                  v-if="$route.query.pageId"
                  :key="$route.query.pageId"
              />
            </div>
          </div>
        </div>
      </div>
    </vue-bottom-sheet>

  </div>
</template>
<script>
import Editor2 from "./Editor2";
import TemplateList2 from "../components/TemplateList2";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import MyCheckbox from "../components/form/MyCheckbox";
import MySwitch from "@/components/form/MySwitch";
import EditText from '@/components/form/EditText';
import {mapMutations, mapGetters} from 'vuex';
export default {
    components:{
    Editor2,
    TemplateList2,
    VueBottomSheet,
    MyCheckbox,
    EditText,
    MySwitch,
  },
  computed:mapGetters({
    login: 'login', // 로그인 상태
  }),
  data: () => ({
    pageName:'',
    pageList: [],
    meditor:false,
    blockList: [],
  }),
  watch:{
    meditor:function () {
      if(this.meditor)
        this.$refs.editor.open()
      else
        this.$refs.editor.close()
    },
  },
  methods: {
    close_editor: function(){
      // 에디터 닫기
      this.meditor = false

      // URL param 중 pageId 값 제거
      let query = {};
      for(let key in this.$route.query){
        query[key] = this.$route.query[key]
      }
      if(query.pageId != undefined){
        delete query.pageId
        this.$router.replace({query:query});
      }
    },
    show_content:function () {
      try {
        this.$refs.content_editor.viewPage()
      } catch (e) {}
    },
    save_content:function () {
      try {
        this.$refs.content_editor.putEditor()
      } catch (e){}
    },
    show_editor:function () {
      this.meditor = true
    },
    added_page:function () {
      try {
        this.getPages()
        this.$refs.myBottomSheet.close()
      } catch (e) {}
    },
    add_page:function () {
      this.$refs.myBottomSheet.open()
    },
    changeUrl:function (item) {
      item.pageUrl_edit = item.pageUrl_edit.trim().split(' ').join('')

      // 값이 입력이 안되었다.
      if(!item.pageUrl_edit) {
        this.$eventBus.$emit('error', '주소를 입력해주세요')
        item.pageUrl_edit = item.pageUrl
        return
      }

      var that = this
      this.updatePageInfo(item.pageId, 'pageUrl', item.pageUrl_edit, function () {
        item.pageUrl = item.pageUrl_edit
        that.$eventBus.$emit('info', '설정이 변경되었습니다.')
      })
    },
    changeName:function (item) {

      item.pageName_edit = item.pageName_edit.trim()

      // 값이 입력이 안되었다.
      if(!item.pageName_edit) {
        this.$eventBus.$emit('error', '이름을 입력해주세요')
        item.pageName_edit = item.pageName
        return
      }

      var that = this
      this.updatePageInfo(item.pageId, 'pageName', item.pageName_edit, function () {
        item.pageName = item.pageName_edit
        that.$eventBus.$emit('info', '설정이 변경되었습니다.')
      })
    },
    changeDisplay:function (item) {

      var that = this

      var v = 0
      if(item.displayYn)
        v = 1

      this.updatePageInfo(item.pageId, 'displayYn', v, function () {
        that.$eventBus.$emit('info', '설정이 변경되었습니다.')
        that.getPages()
      })
    },
    changeRoot:function (item) {

      var that = this

      var v = 0
      if(item.rootYn)
        v = 1

      this.updatePageInfo(item.pageId, 'rootYn', v, function () {
        that.$eventBus.$emit('info', '설정이 변경되었습니다.')
        that.getPages()
      })
    },
    del:function (item) {
      var that = this
      this.$eventBus.$emit('dlg_confirm', '삭제', '선택한 페이지를 삭제하시겠습니까?', function () {
        // ok
        that.deletePage(item)
      })
    },
    updatePageInfo(id, pageType, newValue, callback){
      const axiosData = {
        pageId: id
      };

      if(pageType == 'pageName') axiosData['pageName'] = newValue;
      else if(pageType == 'pageUrl') axiosData['pageUrl'] = newValue;
      else if(pageType == 'displayYn') axiosData['displayYn'] = newValue;
      else if(pageType == 'rootYn') axiosData['rootYn'] = newValue;

      this.$http
          .patch('/api_home/page', axiosData)
          .then(obj=>{

            if(obj.data.success == 1 && callback) {
              callback()
              return;
            }
          })
          .catch(err=>{console.warn(err.response);})
    },
    getPages(){ // 페이지 리스트를 API 조회하여 화면상에 출력
      this.$http
          .get('/api_home/pages')
          .then(obj=>{
            this.pageList = obj.data.pageList;

            // 편집 페이지 URL인 경우 편집 페이지 자동 열기
            for(let i in obj.data.pageList){
              if(obj.data.pageList[i]['pageId'] == this.$route.query.pageId){
                this.editPage(obj.data.pageList[i]);
              }
            }

            this.pageList.forEach(el=>{
              this.$set(el,'pageName_edit', el.pageName)
              this.$set(el,'pageUrl_edit', el.pageUrl)
              //el.pageName_edit = el.pageName
              if(!!el.rootYn)
                el.rootYn = true
              else
                el.rootYn = false
              if(!!el.displayYn)
                el.displayYn = true
              else
                el.displayYn = false
            })
          })
          .catch(err=>{
            console.warn(err.response);})
    },
    addPage(){
      window.open('/demo', '_self')
    },
    viewPage(item){
      if(item.rootYn == 0 && item.pageUrl == null){ // 페이지 URL 미설정시
        this.$eventBus.$emit('error', '페이지 URL 설정이 필요합니다.')
        return
      }
      let url = item.urlPrefix;
      if(!item.rootYn){
        url += item.pageUrl_edit;
      }
      window.open(url, '_blank')
    },
    editPage(pageInfo){
      let query = {};
      for(let key in this.$route.query){
        query[key] = this.$route.query[key]
      }

      if(query.pageId == undefined || query.pageId != pageInfo.pageId){
        query['pageId'] = pageInfo.pageId
        this.$router.replace({query:query});
      }

      this.pageName = pageInfo.pageName
      this.show_editor()
    },
    deletePage(item){
      const axiosData = {
        pageId: item.pageId
      };
      this.$http
          .delete('/api_home/page', {data: axiosData})
          .then(obj=>{
            // 성공
            for(var i=0;i<this.pageList.length;i++) {
              var o = this.pageList[i]
              if(o==item) {
                this.pageList.splice(i,1)
                break
              }
            }

          })
          .catch(err=>{console.warn(err.response);})
    },
    copy(item) {
      // const url = item.fullUrl;
      const url = item.urlPrefix + item.pageUrl_edit;
      const el = document.createElement('textarea');
      el.value = url;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$eventBus.$emit('info', '주소가 복사되었습니다.')
    },
    getParameterByName(name, url){ // 브랜드부스터
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
  },
  mounted:function() {
    this.$store.commit('nav_name','나의 페이지')
    this.$store.commit('page_name','페이지 설정')
    this.getPages();
  },
}
</script>